export const API_STATUS = {
    LOADING: "loading",
    SUCCESS: "success",
    ERROR: "error"
}

export const INITIAL_FIELD_STATE = {
    value: "",
    errors:[], 
    touched: false 
}

export const ACCESS_TOKEN = "accessToken";
export const REFRESH_TOKEN = "refreshToken";
